<button (click)="onTicketClick()" mat-stroked-button class="ticket-expand">
  <div class="ticket-content">
    @if (resourceImageUrl) {
      <img
        [src]="resourceImageUrl"
        alt="resource image"
        class="resource-image"
      />
    }
    @if (!resourceImageUrl) {
      <i class="fas fa-user resource-icon" mat-list-icon></i>
    }
    <div class="ticket-details">
      @if (ticket.resourceAvailability) {
        <div>
          <span class="resource-name">{{
            ticket.resourceAvailability.resource.name
          }}</span>
          @if (ticket.lockToResource) {
            <mat-icon
              fontIcon="fa-lock"
              fontSet="far"
              class="lock-icon"
            ></mat-icon>
          }
          @if (draft) {
            <span>*</span>
          }
        </div>
      }
      @if (!ticket.resourceAvailability) {
        <div>
          {{ ticket.skillProfile?.description ?? "No skills required" }}
        </div>
      }
      <div>{{ ticket.duration }} minutes</div>
    </div>
  </div>
</button>
